import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['content']
  static classes = ['visible']

  show() {
    this.contentTarget.classList.add(this.visibleClass)
  }

  hide() {
    this.contentTarget.classList.remove(this.visibleClass)
  }
}
